exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-0687cd6f]{text-align:center;font-size:25px;background:rgba(0,0,0,.06);border-bottom:1px solid #000}.body[data-v-0687cd6f]{line-height:50px;font-size:20px;overflow:hidden}.body-title[data-v-0687cd6f]{width:125px;float:left;height:40px}.body-content[data-v-0687cd6f]{width:1143px!important;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-0687cd6f","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/electronicMedicalRecord/patient/parts/home/home.vue
// module id = CPyL
// module chunks = 0